import { render, staticRenderFns } from "./Silence.vue?vue&type=template&id=22aa301c&"
import script from "./Silence.vue?vue&type=script&lang=js&"
export * from "./Silence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports